module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhBAMAAAClyt9cAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAVUExURUdwTCW5uSO0tCW6uiS3tye4uCK6uqfkV/IAAAAHdFJOUwBmF1xNNSg3FIlIAAAAhklEQVQoz5XRMQqAMAyF4aIewIfgrKC7HXTv4K438P6n0Faryctkxw/yE1Ln/rzRr52CAUDLAHQMmBi+sQxoGICD4Q4VXkgKlQLu0C4lhYKSGPJKWiONmYqhHhyqtNTXhkYoFKU3UhkpjOhQEhXaHIWWdEQRmp9DB4Y39EIOffCEZvnru4ATZDsd+2YrkUEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/membership/bottomLeftDecor@3x.png
// module id = 1797
// module chunks = 0